import React from 'react';
export const Purse = ({
  color = 'currentColor',
  width = '18px',
  height = '18px',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18 18'
    >
      <g data-name='Group 2'>
        <g
          data-name='Group 1'
          fill={color}
          stroke='#fff'
          strokeMiterlimit='10'
          strokeWidth='.091'
          transform='translate(-85.169 -7.348)'
        >
          <path
            data-name='Path 1'
            d='M98.946 11.381l.217-.061a5.124 5.124 0 00-.6-1.341 11.3 11.3 0 00-1.04-1.279 4.724 4.724 0 00-.93-.679l-.269-.143a3.735 3.735 0 00-.88-.323 5.437 5.437 0 00-1.274-.167l-.317.014a5.3 5.3 0 00-.957.152c-.1.024-.2.061-.3.092a5.009 5.009 0 00-.846.374 4.734 4.734 0 00-.93.679 5.709 5.709 0 00-1.639 2.615l.217.061.217.061a4.7 4.7 0 01.972-1.8 5.106 5.106 0 01.6-.508 4.982 4.982 0 01.874-.521 5.2 5.2 0 011.018-.35 5.315 5.315 0 011.1-.123 5.5 5.5 0 011.1.123 5.2 5.2 0 011.018.35 4.99 4.99 0 01.874.521 5.066 5.066 0 01.585.5 4.7 4.7 0 01.982 1.806z'
          />
          <path
            data-name='Path 2'
            d='M93.787 22.392a22.149 22.149 0 01-8.561-1.727l3.3-9.285h11.282l3.3 9.285a22.149 22.149 0 01-8.561 1.727z'
          />
          <path
            data-name='Path 3'
            d='M88.531 11.381l-1.353 3.8a17.645 17.645 0 006.609 1.351h.765a17.643 17.643 0 006.609-1.351l-1.353-3.8z'
          />
          <path
            data-name='Path 4'
            d='M88.531 11.23l-1.225 3.442a14.059 14.059 0 006.481 1.71h.765a14.059 14.059 0 006.481-1.71l-1.224-3.442z'
          />
          <rect
            data-name='Rectangle 26'
            width='2.01'
            height='2.01'
            rx='.672'
            transform='rotate(-44.999 66.026 -103.976)'
          />
          <path
            data-name='Path 5'
            d='M101.162 15.182h0l-.173-.486a14.034 14.034 0 01-6.436 1.687h-.273v.15h.272a17.649 17.649 0 006.61-1.351z'
          />
          <rect
            data-name='Rectangle 27'
            width='2.01'
            height='2.01'
            rx='.672'
            transform='rotate(-44.999 66.026 -103.976)'
          />
          <rect
            data-name='Rectangle 28'
            width='1.5'
            height='1.5'
            rx='.501'
            transform='rotate(-44.999 66.206 -104.411)'
          />
        </g>
      </g>
    </svg>
  );
};
